export default __webpack_public_path__ + "static/media/notExistGameServer.7fe9465d.svg";